// アプリで必要な title, location, reloadable を得る
import LocalizationData from './LocalizationData'

// URL(path)にマッチする正規表現
const trainPositionsURLRegexp = /^\/lines\/[^\/]+\/trains(#.*)?$/
const singleTrainPositionURLRegexp = /^\/lines\/[^\/]+\/trains\/\d+(#.*)?$/
const routeMapURLRegexp = /^\/lines\/[^\/]+\/route_map(#.*)?$/
const stationViewURLRegexp = /^\/stations\/[^\/]+\/station_view(#.*)?$/
const stationDetailURLRegexp = /^\/stations\/[^\/]+(#.*)?$/

class URLMetaData {
  // 下記画面のみカスタムスキーマのURLに遷移する必要がある
  // * 列車走行位置
  // * 列車情報
  // * 路線図
  // * 駅情報
  // * StationView
  static isNeededToNotifyURLToApp(location) {
    if (trainPositionsURLRegexp.test(location)) return true
    if (singleTrainPositionURLRegexp.test(location)) return true
    if (routeMapURLRegexp.test(location)) return true
    if (stationViewURLRegexp.test(location)) return true
    if (stationDetailURLRegexp.test(location)) return true

    return false
  }

  // 位置座標ボタンを表示するか？(在線位置情報画面のみ true)
  static getIsCoordAcceptable(location) {
    return trainPositionsURLRegexp.test(location)
  }

  // リロードボタンを表示するか?(路線図のみ false)
  static getIsReloadable(location) {
    return !routeMapURLRegexp.test(location)
  }

  // アプリで表示する title 文字列
  static getTitle(location, locale) {
    const pageId = this.getPageIdFromLocation(location)
    return LocalizationData.getMessagesData(locale)[`PageTitle.${pageId}`]
  }

  // 翻訳キーの末端部分
  static getPageIdFromLocation(location) {
    if (trainPositionsURLRegexp.test(location)) return 'TrainPositions'
    if (singleTrainPositionURLRegexp.test(location)) return 'TrainPositions'
    if (routeMapURLRegexp.test(location)) return 'RouteMap'
    if (stationViewURLRegexp.test(location)) return 'StationView'
    if (stationDetailURLRegexp.test(location)) return 'StationDetail'

    alert(`${location}の翻訳が未定義`)
  }
}

export default URLMetaData